import { cx } from '@chakra-ui/utils';
import type {
  OptionProps as ReactSelectOptionProps,
  OptionTypeBase,
} from 'react-select';

import { Box, type BoxProps } from '@frontend/components';
import { AssistanceIcon } from '@frontend/components/src/components/mediaAndIcons/icons/iconSet';

import { useSelectStyles } from '../SelectStylesContext';
import { BASE_CLASS_NAME } from '../const';

export type OptionProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = ReactSelectOptionProps<OptionType, IsMulti> & {
  innerProps: BoxProps;
};

export const Option = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>({
  innerProps,
  innerRef,
  children,
  isFocused,
  isDisabled,
  data = {},
}: OptionProps<OptionType, IsMulti>) => {
  const {
    option: optionStyles,
    optionSuggestionIcon: optionSuggestionIconStyles,
  } = useSelectStyles();

  return (
    <Box
      ref={innerRef}
      className={cx(`${BASE_CLASS_NAME}__option`, innerProps.className)}
      role="button"
      sx={{
        ...(isFocused && {
          bg: 'interaction.surfaceHover',
        }),
        ...(data.isSuggestion && {
          ...(isFocused && {
            bg: 'interaction.surfaceSuggestionHover',
          }),
          _active: {
            bg: 'interaction.surfaceSuggestionActive',
          },
        }),
      }}
      __css={optionStyles}
      {...innerProps}
      {...(isDisabled && { disabled: true })}
    >
      {children}
      {data.showSuggestionIcon ? (
        <AssistanceIcon
          __css={optionSuggestionIconStyles}
          color={isDisabled ? 'interaction.disabled' : 'interaction.suggestion'}
        />
      ) : null}
    </Box>
  );
};
